import { isAndroid } from "react-device-detect";

declare global {
  interface Window {
    JSBridge: any;
  }
}

export const isAndroidApp: boolean = isAndroid && window.JSBridge !== undefined;